import React from "react";
import Paper from "@material-ui/core/Paper";
import checkIcon from "../../Assets/Svg/check.svg";
import SectionHeaderExtraSmall from "../Headers/sectionHeaderExtraSmall";

export const Component = ({ data, onselect, selection }) => (
  <Paper
    onClick={() =>
      !data.isbalancing && data.mastercomponentid !== 101 && onselect(data)
    }
    style={{ height: 436 }}
    className={
      data.isselected
        ? "salary-component rounded-rectangle-paper selected"
        : "salary-component rounded-rectangle-paper"
    }
  >
    <div
      className={
        data.componenttypeid == 1
          ? "bg-light-blue margin-bottom-16 padding8"
          : "bg-light-red margin-bottom-16 padding8"
      }
    >
      <p className={`salary-component-name`}>
        {data.componenttypeid == 1 ? "Income" : "Deduction"}
      </p>
    </div>
    <div className="salary-component-data thin-scroll">
      <div className="salary-component-details padding-top-0">
        <div className="margin-bottom-8">
          <p className="salary text-align-center"> {data.displayname}</p>
        </div>
        <Paper className="padding8 rectangle-paper padding-left-16">
          <div className="margin-bottom-8">
            {/* <SectionHeaderExtraSmall
              header={`${data.componenttypename}     ✅ `}
            /> */}
            <span className="extra-small-dark-secondary floatleft">
              {data.componenttypename}
            </span>
            <span className="extra-small-dark floatright margin-right-6">
              ✅
            </span>
            <div className="clear-float"></div>
          </div>
          <div className="margin-bottom-8">
            {/* <SectionHeaderExtraSmall
              header={`${data.paidastypename}     ✅ `}
            /> */}
            <span className="extra-small-dark-secondary floatleft">
              {data.paidastypename}
            </span>
            <span className="extra-small-dark floatright margin-right-6">
              ✅
            </span>
            <div className="clear-float"></div>
          </div>
          <div className="margin-bottom-8">
            {/* <SectionHeaderExtraSmall
              header={`${
                data.istaxfree
                  ? "Taxed     ✅ "
                  : `Not taxable ${
                      data.mastertaxgroupname
                        ? `:${data.mastertaxgroupname}     ❌ `
                        : "    ❌ "
                    }`
              }`}
            /> */}
            <span className="extra-small-dark-secondary floatleft">Taxed</span>
            <span className="extra-small-dark floatright margin-right-6">
              {data.istaxfree ? "✅" : "    ❌ "}
            </span>
            <div className="clear-float"></div>
          </div>
          <div className="margin-bottom-8">
            {/* <SectionHeaderExtraSmall
              header={`${
                data.isvariable ? "Variable     ✅ " : "Not variable     ❌ "
              }`}
            /> */}
            <span className="extra-small-dark-secondary floatleft">
              Variable
            </span>
            <span className="extra-small-dark floatright margin-right-6">
              {data.isvariable ? "✅" : "❌"}
            </span>
            <div className="clear-float"></div>
          </div>
          <div className="margin-bottom-8">
            <span className="extra-small-dark-secondary floatleft">
              Acrrual
            </span>
            <span className="extra-small-dark floatright margin-right-6">
              {data.isaccrual ? "✅" : "❌"}
            </span>
            <div className="clear-float"></div>
          </div>
          <div className="margin-bottom-8">
            <span className="extra-small-dark-secondary floatleft">
              Statutory
            </span>
            <span className="extra-small-dark floatright margin-right-6">
              {data.isstatutory
                ? "✅"
                : "❌"}
            </span>
            <div className="clear-float"></div>
          </div>
          <div className="margin-bottom-8">
            <span className="extra-small-dark-secondary floatleft">
              Statutory deduction
            </span>
            <span className="extra-small-dark floatright margin-right-6">
              {data.govstatutorytypeid ? "✅" : "❌"}
            </span>
            <div className="clear-float"></div>
          </div>
        </Paper>
        <div className="padding16">
          <p className="extra-small-dark-secondary t-bold">Journal voucher</p>
          <div className="extra-small-dark-secondary margin-top-8">
            {data.journalvoucher || "-"}
          </div>
        </div>
      </div>
    </div>
    {data.isselected && (
      <div className="edit-div">
        <span className="edit-icon-blue">
          <img height="24" src={checkIcon}></img>
        </span>
        {/* {!selection && <span className="medium-text-blue-bold">Edit</span>} */}
      </div>
    )}
  </Paper>
);

export default Component;
